import {
  PORTFOLIOS_CHANGED,
  PORTFOLIOS_SELECTED,
  PORTFOLIOS_LOGOUT
} from '../../const/actionsType';

export function acPortfoliosChanged(pObj) {
  return {
    type: PORTFOLIOS_CHANGED,
    payload: pObj
  };
}

export function acPortfoliosSelected(pObj) {
  return {
    type: PORTFOLIOS_SELECTED,
    payload: pObj
  };
}

export function acPortfoliosLogout() {
  return {
    type: PORTFOLIOS_LOGOUT
  };
}
